import React, { Component } from "react";
import axios from "axios";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { Button, Table } from "antd";
import v from "voca";
import { Link } from "react-router-dom";

const { Column } = Table;

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            interfacetexts: [],
        };
    }

    async componentDidMount() {
        this.setState({
            interfacetexts: await Index.getInterfaceTexts(),
        });
    }

    static async getInterfaceTexts() {
        const result = await axios.get("/api/v1/interfacetexts");
        return result.data;
    }

    render() {
        const { t } = this.props;
        const { interfacetexts } = this.state;
        return (
            <>
                <Table dataSource={interfacetexts} rowKey={interfacetext => interfacetext.id} pagination={{ pageSize: 20 }}>
                    <Column title="Key" key="key" render={interfacetext => interfacetext.key}/>
                    <Column title="Value" render={interfacetext => interfacetext.value["nl-BE"]}/>
                    <Column key="actions" title={v.titleCase(t("action_plural"))} render={interfacetext => <><Link
                        to={{
                            pathname: `/interfacetexts/${interfacetext.id}`,
                            state: {
                                interfacetext,
                            },
                        }}><Button icon="edit"/></Link></>}/>
                </Table>
                <Link
                    to={{
                        pathname: "/interfacetexts/create",
                    }}
                >
                    <Button icon="plus">{v.titleCase(t("interfacetext_new"))} </Button>
                </Link></>
        );
    }
}

export default withTranslation()(Index);
